<template>
  <div class="__ListWrapper">
    <div class="__ListWrapper_Header">
      <!--Search Box-->
      <CSearchBox v-model="searchQuery" :placeholder="filterPlaceholder" />

      <!--Actions-->
      <div class="__ListWrapper_Header_Actions" v-if="$slots.actions">
        <slot name="actions" :data="data" />
      </div>
    </div>

    <div class="__ListWrapper_Body">
      <slot name="body-top" />

      <template v-if="isNoData || isNoResult">
        <div class="__ListWrapper_Body-error" v-if="!loading">
          <template v-if="isNoData">
            {{ $t('No {type}', { type: $t(groupBy) }) }}
          </template>

          <template v-else-if="isNoResult">
            {{ $t('No results') }}
          </template>
        </div>
      </template>

      <div class="__ListWrapper_Body_List" v-else>
        <slot name="body" :data="filteredData" />
      </div>

      <CLoading :loading="loading" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { searchFilter } from '@/lib/searchFilterFn';
import CLoading from '@/components/uikit/CLoading';
import CSearchBox from '@/components/uikit/CSearchBox';
import { mapState } from 'vuex';

const messages = {
  messages: {
    en: {
      account: 'accounts',
      acc_group: 'groups',
      cross_tag: 'tags',
      'No {type}': 'No {type}',
      'No results': 'No results',
    },
    ja: {
      account: 'アカウント',
      acc_group: 'グループ',
      cross_tag: 'タグ',
      'No {type}': '{type}がありません',
      'No results': '検索結果がありません',
    },
  },
};

export default Vue.extend({
  name: 'ListWrapper',
  i18n: messages,
  components: { CLoading, CSearchBox },
  props: {
    data: {
      type: Array,
      default: () => [],
      required: true,
    },
    loading: {
      type: Boolean,
    },
    noDataLabel: {
      type: String,
      default: 'No data',
    },
    filterKeys: {
      type: Array,
      default: () => {
        return [];
      },
    },
    filterPlaceholder: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      searchQuery: '',
    };
  },
  computed: {
    ...mapState('usageReports', {
      groupBy: state => state.groupBy,
    }),

    isNoData() {
      return this.data.length === 0;
    },
    isNoResult() {
      return this.filteredData.length === 0;
    },

    filteredData() {
      return searchFilter(this.data, this.filterKeys, this.searchQuery);
    },
  },
});
</script>

<style lang="scss" scoped>
.__ListWrapper {
  &_Header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: $space-xs 0;
    border-bottom: 1px solid $border-color;

    &_Actions {
      border-left: 1px solid $border-color;
      margin-left: $margin-sm;
      padding-left: $padding-xs;
    }
  }

  &_Body {
    position: relative;

    &-error {
      padding: $space-md;
    }

    &_List {
    }
  }
}
</style>
